<template>
  <div class="upload_file_component">
    <div class="btn-group">
      <button v-if="uploadedImage || uploadedKey" @click="uploadFileData" class="btn btn-info btn-xs">
        <v-popover
          class=""
          popoverClass="1111"
          popoverInnerClass="upload_file_component_popover"
          :auto-hide="true">
          <i class="icon-fa icon-fa-eye"></i>
          <template slot="popover">
            <div class="pre_image">
              <img v-if="uploadedImage" :src="uploadedImage.url">
            </div>
          </template>
        </v-popover>
      </button>
      <span type="button" class="btn btn-outline-info btn-xs pointer">
      Выбрать фотографии
          <input type="file" id="uploadPhotos" ref="uploadFilesInput" :disabled="isSaving" @change="filesAdded($event.target.name, $event.target.files)"
                 accept="image/*" class="input-file pointer hidded">
    </span>
      <LoadingButton
        title='<i class="icon-fa icon-fa-save"></i>'
        :loading="isSaving"
        color="#4fc47f"
        :onClick="saveFile"
        className="btn btn-outline-success btn-xs"
      />
    </div>
  </div>
</template>

<script>

import api from "@/api";
import LoadingButton from "@/components/buttons/LoadingButton";

export default {
  components: {LoadingButton},
  props: ['orderId', 'type', 'uploadedKey'],
  data() {
    return {
      isSaving: false,
      uploadedImage: null
    }
  },
  methods: {
    async uploadFileData() {
      if (!this.uploadedImage && this.uploadedKey) {
        const {data} = await api.index('/uploads/getImgLinkByKey?key=' + this.uploadedKey);
        if (data.success) {
          this.uploadedImage = {
            url: data.link
          }
        }
      }
    },
    async saveFile() {
      if (!this.uploadedImage || !this.uploadedImage.file) return;
      this.isSaving = true;
      let formData = new FormData();
      formData.append('order_id', this.orderId);
      formData.append('type', this.type);
      formData.append('file', this.uploadedImage.file);
      const {data} = await api.post('/orders/addFile',
        formData, true);

      if (data.success) {
        toastr['success']('Сохранено!');
      } else {
        toastr['warning'](data.message || 'Ошибка!');
      }
      this.isSaving = false;
    },
    filesAdded(name, files) {
      if (!Object.keys(files).length) return;
      // console.log(files, typeof files, Object.keys(files));
      let images = [];
      this.uploadedImage = null;
      // this.uploadedImages = {};
      Object.keys(files).forEach((k) => {
        const img = new Image();
        img.src = URL.createObjectURL(files[k]);
        let vm = this;
        img.onload = function () {
          let extIndex = files[k].name.lastIndexOf('.') + 1;
          const extension = files[k].name.substring(extIndex);
          // let siteId = false;
          // vm.sitesRequirements.forEach((r) => {
          //   if (siteId) return;
          //   if (r.image_ext === extension && r.images_height === this.height && r.images_width === this.width) {
          //     siteId = r.id;
          //   }
          // });
          // if (siteId) {
          //   vm.uploadedImages[siteId] = {file: files[k], fileData: {tempPhoto: false, width: this.width, height: this.height, ext: extension}, url: URL.createObjectURL(files[k])};
          //   vm.uploadedImages = {...vm.uploadedImages};
          // }
          vm.uploadedImage = {file: files[k], fileData: {tempPhoto: false, width: this.width, height: this.height, ext: extension}, url: URL.createObjectURL(files[k])};
        }
      });
    }
  }
}
</script>

<style scoped>
.pre_image img {
  max-width: 200px;
  max-height: 200px;
}

.hidded {
  width: 100%;
  height: 100%;
  opacity: 0;
  position: absolute;
  top: 0;
  right: 0;
}
</style>

<style>
.upload_file_component_popover {
  max-width: 250px;
}
</style>
